import resolveConfig from 'tailwindcss/resolveConfig';

import { Config } from 'tailwindcss/types/config';

import tailwindConfig from '../tailwind/themes';

// Resolved without widening to `Config` first: the cast erased the literal theme, leaving callers
// with Tailwind's stock palette type instead of ours (no `darkBlue`, no `cyan.DEFAULT`, ...).
const resolvedConfig = resolveConfig({ content: [], ...tailwindConfig } satisfies Config);

export const tailwindColors = resolvedConfig.theme.colors;

export const tailwindBreakpoints = resolvedConfig.theme.screens;
